<script>
import 'animate.css'
import { WOW } from 'wowjs'

export default {
  data() {
    return {
      list: [
        {
          title: '開店行銷與管理顧問',
          subTitle: 'Marketing Management',
          content: '<p>專業團隊提供開店與行銷的顧問服務，針對您的開店與服務進行健診，打造更有效率與創造營收的寵物服務！</p>',
          bg: require('@assets/images/basicplan/blob-1.svg'),
          img1: require('@assets/images/adminImgs/interface12@1.png'),
          img2: require('@assets/images/adminImgs/interface12@1.png'),
        },
        {
          title: '品牌形象拍攝',
          subTitle: 'Brand Image',
          content: '<p>提供最佳品牌的拍攝服務，打造專業感與品牌質感，讓新客更加了解服務的價值與創造更多的收益！</p>',
          bg: require('@assets/images/basicplan/blob-2.svg'),
          img1: require('@assets/images/adminImgs/pic01@1.jpg'),
          img2: require('@assets/images/adminImgs/pic01@1.jpg'),
        },
        {
          title: '行銷與廣告',
          subTitle: 'Design Marketing',
          content: '<p>協助針對目前店面經營的問題，打造專屬行銷活動與設計，也能針對廣告投放，進行客製化的有效操作，結合愛寵訂服務，真正看到成效！</p>',
          bg: require('@assets/images/basicplan/blob-3.svg'),
          img1: require('@assets/images/adminImgs/pic02@1.jpg'),
          // img2: require('@assets/images/adminImgs/basicplan_emplouees.png'),
        },
        {
          title: 'Google 本地商家資訊建置',
          subTitle: 'Google',
          content: '<p>協助打造滿分的本地商家資訊，結合愛寵訂服務，讓客人在搜尋時就滿馬上產生興趣！</p>',
          bg: require('@assets/images/basicplan/blob-2.svg'),
          img1: require('@assets/images/adminImgs/pic03@1.jpg'),
          // img2: require('@assets/images/adminImgs/basicplan_schedule.png'),
        },
      ]
    }
  },
  mounted() { 
    this.$nextTick(() => {  
      let wow = new WOW({
        live:false
      })
      wow.init()
    })
  }
}
</script>

<template>
  <div :class="$style.sectionFeatures">
    <!-- <img src="@assets/images/home/section7-image.png" alt="" class="sectionSecondary__img"> -->
    <div class="container section">
      <div 
        v-for="(item, $index) in list"
        :key="$index"
        class="row sectionFeatures__list text-xl-left text-center" 
        :class="{ 'flex-row-reverse': $index % 2 === 1 }"
      >
        <div class="col-xl-5 col-12 align-self-center">
          <div v-if="$index % 2 === 1" class="wow animate__animated animate__fadeInRight">
            <BaseSectionTitle 
              :title="item.title" 
              :sub-title="item.subTitle" 
              class="isStyleDecoration mx-xl-0 isxlCenter mx-auto"
            />
            <div class="sectionFeatures__content" v-html="item.content">

            </div>
          </div>
          <div v-else class="wow animate__animated animate__fadeInLeft">
            <BaseSectionTitle 
              :title="item.title" 
              :sub-title="item.subTitle" 
              class="isStyleDecoration mx-xl-0 isxlCenter mx-auto"
            />
            <div class="sectionFeatures__content" v-html="item.content">

            </div>
          </div>
        </div>
        <div class="col-xl-7 col-12 sectionFeatures__img">
          <div
            v-if="$index % 2 === 1" 
            :class="`sectionFeatures__img--item item${$index}`"
            class="mt-xl-0 mt-5 wow animate__animated animate__fadeInLeft left"
          >
            <img
              class="img" 
              :src="item.img1" 
              alt=""
            >
          </div>
          <div
            v-else
            :class="`sectionFeatures__img--item item${$index}`"
            class="mt-xl-0 mt-5 wow animate__animated animate__fadeInRight right"
          >
            <img
              class="img" 
              :src="item.img1"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.sectionFeatures {
  position: relative;
  overflow: hidden;
  margin-top: -40px;
  @include max-xl {
    margin-top: -70px;
  }
  @include max-lg {
    margin-top: 0;
    padding-top: 0px;
  }
  // &:before {
  //   content:'';
  //   position: absolute;
  //   background-image: url('@assets/images/basicplan/paw-1.svg');
  //   background-repeat: no-repeat;
  //   background-size: cover;
  //   width: 9%;
  //   padding-bottom: 10%;
  //   top: 15%;
  //   left: 0;
  //   @include max-lg {
  //     display: none;
  //   }
  // }
  &:after {
    content:'';
    position: absolute;
    background-image: url('@assets/images/basicplan/paw-2.svg');
    background-repeat: no-repeat;
    background-size: cover;
    width: 9%;
    padding-bottom: 11%;
    bottom: 17%;
    right: 0;
    @include max-lg {
      display: none;
    }
  }
  :global {
    .sectionFeatures {
      &__img {
        // position: relative;
        // padding-bottom: 34%;
        // // @include max-md {
        // //   padding-bottom: 78%;
        // // }
        // .img {
        //   position: absolute;
        //   top: 0;
        //   left: 0;
        //   right: 0;
        //   bottom: 0;
        //   // background: #bed6da;
        //   background-size: cover;
        //   background-repeat: no-repeat;
        //   background-position: center;
        // }
      }
      &__content {
        color: $color-text-2;
        @include max-md {
          font-size: 14px;
        }
      }
      &__img {

        &--item {
          position: relative; 
          &:before {
          content: '';
          position: absolute;
          background-size: cover;
          background-repeat: no-repeat;
          }
          &.right {
            padding-left: 70px;
            @include max-xl {
              padding-left: 0;
            }
          }
          &.left {
            padding-right: 70px;
            @include max-xl {
              padding-right: 0;
            }
          }
          
          &.item0 {
            &:before {
              background-image: url('~@assets/images/basicplan/blob-1.svg');
              width: 77%;
              padding-bottom: 72%;
              top: -7%;
              right: -10%;
              
            }
          }
          &.item1 {
            &:before {
              background-image: url('~@assets/images/basicplan/blob-2.svg');
              width: 72%;
              padding-bottom: 64%;
              left: -15%;
              bottom: -30%;
            }
          }
          &.item2 {
            &:before {
              background-image: url('~@assets/images/basicplan/shutterstock_551338465.svg');
              width: 72%;
              padding-bottom: 64%;
              right: -20%;
              top: -34%;
            }
          }
          &.item3 {
            &:before {
              background-image: url('~@assets/images/basicplan/blob-3.svg');
              width: 45%;
              padding-bottom: 46%;
              left: -16%;
              top: -17%;
            }
          }
           &.item4 {
            &:before {
              background-image: url('~@assets/images/basicplan/blob-5.svg');
              width: 60%;
              padding-bottom: 65%;
              right: -16%;
              top: -30%;
            }
          }
        }
        
        .img {
          position: relative;
          z-index: 3;
          box-shadow: 0px 5px 20px rgba(40, 45, 78, 0.2);
          border-radius: 10px;
        }
      }
      &__list {
        &:not(:first-child) {
          margin-top: 230px;
          @include max-xl {
            margin-top: 116px;
          }
        }
        
      }
    }
    
  }
}
</style>